<template>
    <div class="js-mailkit-embed">
    </div>
</template>

<script setup>
import { onMounted } from 'vue';

onMounted(() => {
    const script = document.createElement('script');
    script.src = 'https://yellowwood-adventures.kit.com/cb4a76b5ef/index.js';
    script.dataset.uid = 'cb4a76b5ef'; // Adding the data-uid attribute
    script.async = true;

    let embeds = document.querySelectorAll(".js-mailkit-embed");
    embeds.forEach((embed) =>
    {
      embed.appendChild(script);
    })
});
</script>

